import React, { useState, useCallback } from "react";

// @notus-pro/react
import HTMLFlipBook from "react-pageflip";

// const Page = React.forwardRef((props, ref) => {
//   return (
//     <div className="demoPage" ref={ref}>
//       <h1>Page Header</h1>
//       <p>{props.children}</p>
//       <p>Page number: {props.number}</p>
//     </div>
//   );
// });

const PageCover = React.forwardRef((props, ref) => {
  return (
    <div className="page page-cover" ref={ref} data-density="hard">
      <div className="page-content">{props.children}</div>
    </div>
  );
});

const Page = React.forwardRef((props, ref) => {
  return (
    <div className="page" ref={ref}>
      <div className="page-content">{props.children}</div>
    </div>
  );
});

export default function BookContent() {
  const onFlip = useCallback((e) => {
    console.log("Current page: " + e.data);
    const element = document.getElementById("thesolarexpress");
    if (element) {
      element.scrollIntoView({
        behavior: "smooth",
        block: "center",
        inline: "center",
      });
    }
  }, []);

  return (
    <HTMLFlipBook
      width={720}
      height={840}
      size="stretch"
      minWidth={360}
      maxWidth={1440}
      minHeight={420}
      maxHeight={1280}
      maxShadowOpacity={0.5}
      showCover={true}
      flippingTime={500}
      autoSize={true}
      mobileScrollSupport={true}
      //style={{ margin: "0 auto" }}
      renderOnlyPageLengthChange={true}
      onFlip={onFlip}
    >
      <PageCover number="1">
        <img alt="..." className="object-contain" src="../images/Slide1.png" />
      </PageCover>
      <Page number="2">
        <img alt="..." className="object-contain" src="../images/Slide2.png" />
      </Page>
      <Page number="3">
        <img alt="..." className="object-contain" src="../images/Slide3.png" />
      </Page>
      <Page number="4">
        <img alt="..." className="object-contain" src="../images/Slide4.png" />
      </Page>
      <Page number="5">
        <img alt="..." className="object-contain" src="../images/Slide5.png" />
      </Page>
      <Page number="6">
        <img alt="..." className="object-contain" src="../images/Slide6.png" />
      </Page>
      <Page number="7">
        <img alt="..." className="object-contain" src="../images/Slide7.png" />
      </Page>
      <Page number="8">
        <img alt="..." className="object-contain" src="../images/Slide8.png" />
      </Page>
      <Page number="9">
        <img alt="..." className="object-contain" src="../images/Slide9.png" />
      </Page>
      <Page number="10">
        <img alt="..." className="object-contain" src="../images/Slide10.png" />
      </Page>
      <Page number="11">
        <img alt="..." className="object-contain" src="../images/Slide11.png" />
      </Page>
      <Page number="12">
        <img alt="..." className="object-contain" src="../images/Slide12.png" />
      </Page>
      <Page number="13">
        <img alt="..." className="object-contain" src="../images/Slide13.png" />
      </Page>
      <Page number="14">
        <img alt="..." className="object-contain" src="../images/Slide14.png" />
      </Page>
      <Page number="15">
        <img alt="..." className="object-contain" src="../images/Slide15.png" />
      </Page>
      <Page number="16">
        <img alt="..." className="object-contain" src="../images/Slide16.png" />
      </Page>
      <Page number="17">
        <img alt="..." className="object-contain" src="../images/Slide17.png" />
      </Page>
      <Page number="18">
        <img alt="..." className="object-contain" src="../images/Slide18.png" />
      </Page>
      <Page number="19">
        <img alt="..." className="object-contain" src="../images/Slide19.png" />
      </Page>
      <Page number="20">
        <img alt="..." className="object-contain" src="../images/Slide20.png" />
      </Page>
      <Page number="21">
        <img alt="..." className="object-contain" src="../images/Slide21.png" />
      </Page>
      <Page number="22">
        <img alt="..." className="object-contain" src="../images/Slide22.png" />
      </Page>
      <Page number="23">
        <img alt="..." className="object-contain" src="../images/Slide23.png" />
      </Page>
      <Page number="24">
        <img alt="..." className="object-contain" src="../images/Slide24.png" />
      </Page>
      <Page number="25">
        <img alt="..." className="object-contain" src="../images/Slide25.png" />
      </Page>
    </HTMLFlipBook>
  );
}
